<template>
    <div>
        <section v-if="!modalidades || modalidades.length === 0">
            <div class="row">
                <div class="col s12">
                    <p class="center">
                        <span class="grey-text" style="font-style: italic">Não há modalidades cadastradas até o momento...</span>
                    </p>
                </div>
            </div>
        </section>


        <section v-else>
            <div class="row">
                <div class="col s12">
                    <div class="row" v-for="(modalidade, modalidade_i) in modalidades"
                         :key="modalidade_i">
							<h5>{{modalidade.descricao}}</h5>

                        <div class="input-field col m6 s12">

                            <input type="number"
                                   name="numero_meses"
                                   :id="`numero_meses_${modalidade_i}`"
                                   v-model.number="modalidade.numero_meses"
								   :readonly='bloqueio == true'/> 
							<label :for="`numero_meses_${modalidade_i}`">Duração (Meses)</label>
                        </div>

                        <div class="row">
                            <div class="col s12">
                                <table class="responsive-table">
                                    <thead>
                                    <tr>
                                        <th>
                                            <h6 class="title">Bolsas de Extensão</h6>
                                        </th>
                                        <th colspan="2">
                                            <a v-if='!bloqueio' class="btn-floating btn-small waves-effect waves-light light-blue lighten-1 right"
                                               @click.prevent="adicionaUmaNovaBolsaDeExtensao(modalidade)"
                                               title="Adicionar">
                                                <i class="material-icons">add</i>
                                            </a>
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-if="!modalidade.hasOwnProperty('bolsas_extensao') || modalidade.bolsas_extensao.length === 0">
                                        <td><p class="label-info-nao-encontrada">Não foi informada nenhuma bolsa de extensão para a modalidade acima!</p></td>
                                    </tr>

                                    <tr v-else v-for="(bolsa, bolsa_i) in modalidade.bolsas_extensao">
                                        <td>
                                            <span style="font-weight: bold;">Código:</span>&nbsp;
                                            <select :name="`sel_bolsa_codigo_${bolsa_i}`" :id="`sel_bolsa_codigo_${bolsa_i}`" class="browser-default"
                                                    v-model="bolsa.codigo"
													:disabled='bloqueio == true'>
                                                <option value="" disabled>Selecione...</option>
                                                <option v-for="(codigo, codigo_i) in listaDeCodigosDeBolsasDeExtensao"
                                                        :disabled="verificaSeCodigoJaEstaSendoUtilizado(modalidade, codigo)"
                                                        :value="codigo" :key="codigo_i" :title="codigo">{{ codigo }}</option>
                                            </select>
                                        </td>
                                        <td>
                                            <span style="font-weight: bold;">Quantidade:</span>&nbsp;
                                            <input type="number"
                                                   :name="`num_qtd_bolsas_${bolsa_i}`"
                                                   :id="`num_qtd_bolsas_${bolsa_i}`"
                                                   min="0"
												   :readonly='bloqueio == true'
                                                   v-model.number="bolsa.quantidade_bolsas" />
                                        </td>
                                        <td>
                                            <a class="btn-floating btn-small waves-effect waves-light red"
                                               @click.prevent="excluiBolsaDeExtensao(modalidade, bolsa_i)"
                                               title="Remover"
											   v-if='!bloqueio'>
                                                <i class="material-icons">delete</i>
                                            </a>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
						<br><br>
                    </div>
                </div>
            </div>


        </section>

        <div class="row">
            <div class="col s12">
                <button type="button"
                        class="btn waves-effect waves-light indigo"
                        @click.prevent="salvaDados"
						v-if='!bloqueio'>
                    <i class="material-icons left">save</i>
                    Salvar
                </button>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "modalidades",
    inject: ['principal'],
    props: {
        pModalidades: {
            type: Array,
            default: () => []
        },
		bloqueio: {
			type: String,
            default: null,
		}
    },
    data() {
        return {
            modalidades: this.pModalidades,

            listaDeCodigosDeBolsasDeExtensao: [
                'I',
                'II',
                'III',
                'IV',
                'V',
                'VI',
                'VII',
                'VIII',
                'XI',
                'X',
            ]
        }
    },
    watch: {
        pModalidades : {
            handler(newValue){
                this.modalidades = newValue
            },
            deep: true,
        },
        modalidades: {
            handler(newValue){
                this.$emit('update:pModalidades', newValue)
            },
            deep: true,
        }
    },
    methods: {
        salvaDados(){
            let temModalidadeSemBolsaDeExtensao = false
            let temModalidadeComBolsaESemCota = false

            _.forEach(this.modalidades, (modalidade) => {
                if(!modalidade.hasOwnProperty('bolsas_extensao') || modalidade.bolsas_extensao.length === 0){
                    temModalidadeSemBolsaDeExtensao = true
                    return false
                } else if(_.findIndex(modalidade.bolsas_extensao, (bolsa) => { return !bolsa.codigo || bolsa.codigo === '' || !bolsa.quantidade_bolsas }) > -1){
                    temModalidadeComBolsaESemCota = true
                    return false
                }
            })

            if(temModalidadeSemBolsaDeExtensao){
                Swal.fire({ title: 'Ação inválida!', text: 'É necessário informar ao menos uma bolsa de extensão para cada modalidade.', icon: 'error'})
                return false;
            }

            if(temModalidadeComBolsaESemCota){
                Swal.fire({ title: 'Ação inválida!', text: 'É necessário informar corretamente o código e a quantidade de bolsas para cada bolsa de extensão selecionada.', icon: 'error'})
                return false;
            }

            this.principal.salva();
        },

        insereCampoBolsasExtensaoCasoNaoTenha(){
            this.modalidades.forEach(modalidade => {
                if(!modalidade.hasOwnProperty('bolsas_extensao')) this.$set(modalidade, 'bolsas_extensao', [])
            })
        },

        adicionaUmaNovaBolsaDeExtensao(modalidade){
            if(!modalidade.bolsas_extensao)
                modalidade.bolsas_extensao = []

            modalidade.bolsas_extensao.push({
                codigo: null,
                quantidade_bolsas: null,
            })
        },

        verificaSeCodigoJaEstaSendoUtilizado(modalidade, codigo){
            return _.findIndex(modalidade.bolsas_extensao, (bolsa) => { return bolsa.codigo === codigo }) > -1
        },

        excluiBolsaDeExtensao(modalidade, indice){
            Swal.fire({
                title: "Confirma exclusão da bolsa de extensão?",
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Sim, pode excluir!",
                cancelButtonText: "Não.",
            }).then((result) => {
                if (result.isConfirmed) {
                    modalidade.bolsas_extensao.splice(indice, 1)
                }
            });
        }
    },
    mounted() {
        M.updateTextFields()
        this.insereCampoBolsasExtensaoCasoNaoTenha()
    },
    updated() {
        M.updateTextFields()
        this.insereCampoBolsasExtensaoCasoNaoTenha()
    }
}
</script>

<style scoped>

</style>
